// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-j_gX","advertDetailHeaderLocation__value":"c-j_gY"};